// THE BUILT-IN BLOG TEMPLATES — what a site's three blog templates are until
// somebody edits them on the Blog tab.
//
// A file of their own, and not in ./blog, because two modules need them and
// neither may import the other: ./blog renders through them, and
// @common/schema/site/blog decides whether a site HAS a template of its own or
// falls back to one of these — which is what the Templates screen shows as
// "Built-in" and what the resolver hands the editor to start from.
//
// The post one is ported from gen-2's blog configuration
// (archive/recovered/stack-pkg/src/data/blog/fields/index.js); the other two
// are the shape gen-2's defaults had, written against what ./blog hands a
// template. What that is — `values.items`, `values.hasNext` and the rest — is
// listed at the top of ./blog.
export const POST = `<article class="blog-post">
  <header>
    <h1><%= values.title %></h1>
    <% if (values.abstract) { %><p class="blog-post-abstract"><%= values.abstract %></p><% } %>
    <% if (values.dateText) { %><time datetime="<%= values.date %>"><%= values.dateText %></time><% } %>
    <% if (values.author) { %><p class="blog-post-author"><%= values.author.name %></p><% } %>
  </header>
  <% if (values.image.url) { %>
  <figure>
    <img class="image" alt="<%= values.image.description %>" src="<%= values.image.url %>"/>
    <% if (values.image.description) { %><figcaption><i><%= values.image.description %></i></figcaption><% } %>
  </figure>
  <% } %>
  <%- values.content %>
</article>`;

const ITEM = `<article class="blog-list-item">
    <h2><a href="<%= item.url %>"><%= item.title %></a></h2>
    <% if (item.dateText) { %><time datetime="<%= item.date %>"><%= item.dateText %></time><% } %>
    <% if (item.abstract) { %><p><%= item.abstract %></p><% } %>
  </article>`;

export const LIST = `<div class="blog-list">
  <% for (const item of values.items) { %>
  ${ITEM}
  <% } %>
  <% if (values.empty) { %><p class="blog-list-empty">No posts yet.</p><% } %>
  <nav class="blog-list-pages">
    <% if (values.hasPrev && values.prevUrl) { %><a rel="prev" href="<%= values.prevUrl %>">Newer</a><% } %>
    <% if (values.hasNext && values.nextUrl) { %><a rel="next" href="<%= values.nextUrl %>">Older</a><% } %>
  </nav>
</div>`;

export const COLLECTION = `<section class="blog-collection">
  <h2><%= values.title %></h2>
  <% if (values.description) { %><p><%= values.description %></p><% } %>
  <% for (const item of values.items) { %>
  ${ITEM}
  <% } %>
  <% if (values.empty) { %><p class="blog-collection-empty">Nothing here yet.</p><% } %>
</section>`;

// Keyed by the template KIND — `post`, `list`, `collection` — which is how a
// site's own templates are stored (`site.blog.templates.<kind>`) and how the
// element types map onto them (see ./blog's KIND_OF). A built-in has markup
// and nothing else; a site's own may carry a style and a script too.
export const DEFAULTS = {
  post: { html: POST, style: "", script: "" },
  list: { html: LIST, style: "", script: "" },
  collection: { html: COLLECTION, style: "", script: "" },
};
